module.exports = __webpack_public_path__ + "img/clubs.7784da7b.svg";